import { createSelector, Selector } from '@ngxs/store';
import { SportEventDefinitionState, SportEventDefinitionStateModel } from './sport-event-definition.state';
import { SessionKind, SportEventDefinitionDto } from '@smatchy/sdk';

export class SportEventDefinitionSelector {
  @Selector([SportEventDefinitionState])
  static loading(state: SportEventDefinitionStateModel): boolean {
    return state.loadingSportSession;
  }

  @Selector([SportEventDefinitionState])
  /** Nothing before a sport's definition is loaded, and the kinds are optional on it. */
  static sessionKinds(state: SportEventDefinitionStateModel): Array<SessionKind> | undefined {
    return state.sportEventDefinition?.sessionsKind;
  }

  @Selector([SportEventDefinitionState])
  /** null until a sport's definition is loaded, which is what the defaults set. */
  static sportEventDefinition(state: SportEventDefinitionStateModel): SportEventDefinitionDto | null {
    return state.sportEventDefinition;
  }

  // @Selector([SportEventDefinitionState])
  static getSportEventDefinition(sportKeyId: string) {
    return createSelector([SportEventDefinitionState], (state: SportEventDefinitionStateModel) => {
      return state.allSportsEventDefinition.find((s) => s.sportKeyId === sportKeyId);
    });
  }

  // @Selector([SportEventDefinitionState])
  static getSessionKindInformation(sportKeyId: string, sessionKindId: string) {
    return createSelector([SportEventDefinitionState], (state: SportEventDefinitionStateModel) => {
      // Through the miss rather than into it: a sport whose definition has not
      // been loaded is not in this list, and reading `sessionsKind` off the
      // absent entry threw.
      const definition = state.allSportsEventDefinition.find((s) => s.sportKeyId === sportKeyId);
      return definition?.sessionsKind?.find((k) => k.id === sessionKindId);
    });
  }
}
